import React from 'react';

import './Checkmark.scss';

const CheckMark = ({ className }) => (
  <svg
    id="remaining-checkmark"
    className={`checkmark checkmark-checked ${className} `}
    width="52px"
    height="52px"
    viewBox="0 0 52 51"
    version="1.1"
  >
    <g id="Big-Buy-/-Step-4" transform="translate(-939.000000, -256.000000)">
      <g id="Group-7" transform="translate(917.000000, 222.000000)">
        <g
          id="check-circle-outline"
          transform="translate(22.000000, 34.000000)"
        >
          <path
            id="Shape"
            className={`college-branded-circle checkmark__circle`}
            fill="#d8d8d8"
            d="M45.9,25.5 C45.9,36.72 36.72,45.9 25.5,45.9 C14.28,45.9 5.1,36.72 5.1,25.5 C5.1,14.28 14.28,5.1 25.5,5.1 C27.54,5.1 29.325,5.355 31.11,5.865 L35.19,1.785 C32.13,0.765 28.815,0 25.5,0 C11.475,0 0,11.475 0,25.5 C0,39.525 11.475,51 25.5,51 C39.525,51 51,39.525 51,25.5 L45.9,25.5 L45.9,25.5 Z"
          />
          <polygon
            className="checkmark__check"
            fill="#63c908"
            points="15.862069 20.4385965 12 24.3684211 24.4137931 37 52 8.92982456 48.137931 5 24.4137931 29.1403509"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default CheckMark;
